import React, { FC } from 'react'
import useGetEvents from '@src/hooks/useGetEvents'
import { beautifyDate, SlimFeatureType } from '@islandsstofa/react'
import { Event } from '@root/src/utils/resolvers'
import SlimFeatureList from '.'
import { Container } from '@kogk/common'

interface Props {
  features: Event[]
  buttonText: string
}

const EventFeatures: FC<Props> = ({ buttonText = 'Sjá nánar', features }) => {
  // if cards are provided then use those... otherwise fetch all
  const events = features ?? useGetEvents()

  return (
    <Container>
      <h2 className='mt-4 mb-4'>Næstu viðburðir</h2>
      <SlimFeatureList
        features={events.slice(0, 3).map(event => {
          return {
            html:
              `<h4>${event.name.text}</h4>` +
              event.excerpt.html +
              `<p><b>${beautifyDate(new Date(event.date))}</b></p>`,
            image: event.image,
            link: {
              url: event.url,
              text: buttonText
            },
            imageTag: event.tags ? event.tags[0] : null
          } as SlimFeatureType
        })}
      />
    </Container>
  )
}

export default EventFeatures
